import { Toast } from "@shopify/app-bridge-react"
import {
    Card,
    Icon,
    Layout,
    Page,
    TextStyle,
    Thumbnail,
    Button,
    Checkbox,
    FormLayout,
    PageActions,
    ResourceList,
    ResourceItem,
    Sheet,
    Heading,
    RadioButton,
    OptionList,
    TextField,
    Scrollable,
    ButtonGroup,
    Stack,
    Spinner,
    ChoiceList,
} from "@shopify/polaris"
import {
    ArrowLeftMinor,
    ExternalMinor,
    SearchMinor,
    CancelSmallMinor,
} from "@shopify/polaris-icons"
import React, { Component } from "react"
import axios from "../../funcs/axios"
import { DateTimePicker } from "react-rainbow-components"
import InfinitScroll from "react-infinite-scroll-component"
import "./style.scss"
import moment from "moment"
export default class MultipleProductDetail extends Component {
    state = {
        loaded: true,
        shop: "",
        variants: "",
        selectItem: {
            name: "New profile",
            applyFor: "products",
            startCondition: { type: "now", condition: null },
            endQuantity: { check: false, condition: "", type: "quantity" },
            endDate: { check: false, condition: "", type: "date" },
            countdown: { endCountdown: false },
            requiredCondition: "auto",
            after_finish: null,
            discount_payment:
                '{"fullPayment":{"enable":true,"discountValue":"10","discountType":"percentage"},"partialPayment":{"enable":true,"value":"10","valueType":"percentage","discountValue":"10","discountType":"percentage"}}',
            status: 1,
            created_at: new Date(),
            updated_at: new Date(),
            sameVariant: true,
        },
        test: null,
        toast: {
            error: false,
            content: "",
            show: false,
        },
        sheetActive: false,
        textSearch: "",
        all_product: [],
        listProducts: [],
        loading: true,
        selected: "",
        loadingEndPoint: false,
        listSelected: [],
    }

    constructor(props: Props) {
        super(props)
        console.log("props", props.productId)
        if (props.productId) {
            axios.post(`${window.ShopifyHost}/admin/load-pre-order`, productId).then((res) => {
                if (res.data.status == "success") {
                    this.setState({ selectItem: res.data.item })
                    this.setState({
                        product: res.data.item,
                        loaded: true,
                        shop: res.data.shop,
                        variants: res.data.item.variants,
                    })
                    this.setState({
                        toast: { show: true, content: res.data.msg, error: false },
                    })
                } else {
                    axios
                        .post(`${window.ShopifyHost}/admin/load-product`, productId)
                        .then((res) => {
                            let product = res.data.product
                            let obj = {
                                id: product.id,
                                name: product.title,
                                handle: product.handle,
                                image: product.image,
                                message: null,
                                startCondition: { type: "now", condition: null },
                                endQuantity: { check: false, condition: "", type: "quantity" },
                                endDate: { check: false, condition: "", type: "date" },
                                countdown: { endCountdown: false },
                                requiredCondition: "auto",
                                after_finish: null,
                                discount_payment:
                                    '{"fullPayment":{"enable":true,"discountValue":"10","discountType":"percentage"},"partialPayment":{"enable":true,"value":"10","valueType":"percentage","discountValue":"10","discountType":"percentage"}}',
                                status: 1,
                                created_at: new Date(),
                                updated_at: new Date(),
                                sameVariant: false,
                            }
                            this.setState({ selectItem: obj })
                            this.setState({
                                product: obj,
                                loaded: true,
                                shop: res.data.shop,
                                variants,
                            })
                            this.setState({
                                toast: { show: true, content: res.data.msg, error: false },
                            })
                        })
                        .catch((err) => console.log(err))
                }
            })
        }
        this.handleGetProduct()
    }

    handleToggleSheetActive = () => {
        const { sheetActive } = this.state
        this.setState({ sheetActive: !sheetActive })
    }

    handleSearch = (val) => {
        let url = `${window.ShopifyHost}/admin/search-product?search=${val}&type=product`
        this.setState({ textSearch: val })
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout)
        }
        if (!val) {
            url = `${window.ShopifyHost}/admin/search-product?type=product`
        }
        this.searchTimeout = setTimeout(() => {
            axios.get(url).then((res) => {
                let data = res.data.list
                let rows = []
                data.map((item) => {
                    return rows.push({
                        value: item.id,
                        label: (
                            <div className="productInfo">
                                <Thumbnail
                                    source={item.featured_image}
                                    size="small"
                                    alt={item.title}
                                />
                                <h3 className="productName">
                                    <TextStyle variation="strong">{item.title}</TextStyle>
                                </h3>
                            </div>
                        ),
                    })
                })
                if (res.data.nextUrl) {
                    this.setState({ nextCursor: res.data.nextUrl })
                } else {
                    this.setState({ nextCursor: "" })
                }
                this.setState({ all_product: rows, loading: false, loadingEndPoint: false })
            })
        }, 500)
    }

    handleGetProduct = () => {
        axios.get(`${window.ShopifyHost}/admin/search-product?type=product`).then((res) => {
            let data = res.data.list
            let rows = []
            this.setState({ listProducts: data })
            data.map((item) => {
                return rows.push({
                    value: item.id,
                    label: (
                        <div className="productInfo">
                            <Thumbnail source={item.featured_image} size="small" alt={item.title} />
                            <h3 className="productName">
                                <TextStyle variation="strong">{item.title}</TextStyle>
                            </h3>
                        </div>
                    ),
                })
            })
            if (res.data.nextUrl) {
                this.setState({ nextCursor: res.data.nextUrl })
            } else {
                this.setState({ nextCursor: "" })
            }
            this.setState({ all_product: rows, loading: false, loadingEndPoint: true })
        })
    }

    handleLoadMore = () => {
        const { all_product } = this.state
        if (this.state.nextCursor) {
            let rows = [...all_product]
            axios
                .get(`${window.ShopifyHost}/admin/search-product?type=product&nextPage=${this.state.nextCursor}`)
                .then((res) => {
                    let data = res.data.list
                    let { listProducts } = this.state
                    let newList = [...listProducts, ...data]
                    this.setState({ listProducts: newList })
                    data.map((item) => {
                        return rows.push({
                            value: item.id,
                            label: (
                                <div className="productInfo">
                                    <Thumbnail
                                        source={item.featured_image}
                                        size="small"
                                        alt={item.title}
                                    />
                                    <h3 className="productName">
                                        <TextStyle variation="strong">{item.title}</TextStyle>
                                    </h3>
                                </div>
                            ),
                        })
                    })
                    if (res.data.nextUrl) {
                        this.setState({ nextCursor: res.data.nextUrl })
                    } else {
                        this.setState({ nextCursor: "" })
                    }
                    this.setState({ all_product: rows, loading: false, loadingEndPoint: true })
                })
        } else {
            this.setState({ loadingEndPoint: false })
        }
    }

    handleSaveProduct = () => {
        axios.post(`${window.ShopifyHost}/admin/save-pre-order`, this.state.product).then((res) =>
            this.setState({
                toast: { show: true, content: res.data.msg, error: false },
            }),
        )
    }

    handleSelect = (val) => {
        this.setState({ selected: val })
    }

    handlSelectListProduct = () => {
        const { listProducts, selected } = this.state
        let list = []
        selected.map((e) => {
            let product = listProducts.find((_e) => _e.id == e)
            list.push(product)
        })
        this.setState({ listSelected: list })
        this.handleToggleSheetActive()
    }

    handleDelete = (id) => {
        const { listSelected, selected } = this.state
        console.log("listSelected", listSelected)
        let index = listSelected.findIndex((e) => e.id == id)
        let indexSelect = selected.findIndex((e) => e == id)
        if (index != -1) {
            listSelected.splice(index, 1)
            selected.splice(indexSelect, 1)
        }
        console.log("id", id)
        this.setState({ listSelected })
    }

    hanldeChange = (key, value) => {
        const { selectItem } = this.state
        let newProduct = { ...selectItem }
        switch (key) {
            case "name":
                newProduct.name = value
                break
            case "applyFor":
                newProduct.applyFor = value
                break
            case "status":
                newProduct.status = !newProduct.status
                break
            case "startCondition": {
                if (value == "now") {
                    newProduct.startCondition.type = "now"
                }
                if (value == "date") {
                    newProduct.startCondition.type = "date"
                    newProduct.startCondition.condition = new Date()
                }
                if (value == "quantity") {
                    newProduct.startCondition.type = "quantity"
                    newProduct.startCondition.condition = "0"
                }
                break
            }
            case "startDate":
                newProduct.startCondition.condition = value
                break
            case "startQuantity":
                newProduct.startCondition.condition = value
                break
            case "requiredCondition":
                newProduct.requiredCondition = value
                break
            case "checkEndQuantity":
                newProduct.endQuantity.check = !newProduct.endQuantity.check
                newProduct.endQuantity.condition = "-10"
                break
            case "endQuantity":
                newProduct.endQuantity.condition = value
                break
            case "checkEndDate":
                newProduct.endDate.check = !newProduct.endDate.check
                let d = new Date()
                d.setDate(d.getDate() + 1)
                newProduct.endDate.condition = d
                break
            case "endDate":
                newProduct.endDate.condition = value
                break
            case "endCountdown":
                newProduct.countdown.endCountdown = !newProduct.countdown.endCountdown
                break
            default:
                break
        }
        console.log("newProduct", newProduct)
        this.setState({ selectItem: newProduct })
    }

    render() {
        const {
            overSelling,
            loaded,
            shop,
            sheetActive,
            selectItem,
            selected,
            toast,
            textSearch,
            loading,
            all_product,
            listSelected,
        } = this.state
        // console.log("selectedItem", selectItem)
        // console.log("selected", selected)
        console.log("listSelected", listSelected)
        const url = `https://${shop}/products`
        return loaded ? (
            <div className="product-detail">
                <div
                    className="product_detail_back"
                    onClick={() => this.props.redirectToPage("MultipleProduct")}
                >
                    <Icon source={ArrowLeftMinor} />
                    <span style={{ marginLeft: "10px" }}>Back to List</span>
                </div>
                <Page
                    // title={selectItem.name}
                    secondaryActions={[
                        {
                            content: "View",
                            external: true,
                            icon: ExternalMinor,
                            url,
                        },
                    ]}
                >
                    <Layout>
                        <Layout.Section secondary>
                            <div className="product-detail-info">
                                <Card title="Profile name" sectioned>
                                    <TextField
                                        placeholder="Profile name"
                                        value={selectItem.name}
                                        onChange={(val) => this.hanldeChange("name", val)}
                                    />
                                </Card>
                                {/* Variant */}
                                <Card title="Apply for">
                                    <Card.Section>
                                        <Stack vertical>
                                            <RadioButton
                                                label="Select products"
                                                checked={selectItem.applyFor === "products"}
                                                id="disabled"
                                                name="apply"
                                                onChange={() =>
                                                    this.hanldeChange("applyFor", "products")
                                                }
                                            />
                                            <RadioButton
                                                label="Select collection"
                                                id="optional"
                                                name="apply"
                                                checked={selectItem.applyFor === "collection"}
                                                onChange={() =>
                                                    this.hanldeChange("applyFor", "collection")
                                                }
                                            />
                                        </Stack>
                                    </Card.Section>
                                    <Card.Section>
                                        <Button
                                            primary
                                            onClick={() => this.handleToggleSheetActive()}
                                        >
                                            Add
                                        </Button>
                                        {/* <FormLayout >
                                            <TextField
                                                placeholder="Search products"
                                                type="search"
                                                prefix={<Icon source={SearchMinor} />}
                                            ></TextField>
                                        </FormLayout> */}
                                    </Card.Section>
                                    {listSelected.length > 0 ? (
                                        <Card>
                                            <Scrollable style={{ maxHeight: "300px" }}>
                                                {/* <ResourceList
                                                    resourceName={{
                                                        singular: "customer",
                                                        plural: "customers",
                                                    }}
                                                    items={listSelected}
                                                    renderItem={(item) => {
                                                        const {
                                                            id,
                                                            title,
                                                            featured_image,
                                                            handle,
                                                        } = item
                                                        const media = (
                                                            <Thumbnail
                                                                source={featured_image}
                                                                // size="small"
                                                                alt={handle}
                                                            />
                                                        )

                                                        return (
                                                            <ResourceItem
                                                                id={id}
                                                                media={media}
                                                                shortcutActions={[
                                                                    {
                                                                        content: (
                                                                            <Icon
                                                                                source={
                                                                                    CancelSmallMinor
                                                                                }
                                                                            ></Icon>
                                                                        ),
                                                                        onAction: () =>
                                                                            this.handleDelete(id),
                                                                    },
                                                                ]}
                                                                persistActions
                                                                accessibilityLabel={`View details for ${title}`}
                                                            >
                                                                <h3>
                                                                    <TextStyle variation="strong">
                                                                        {title}
                                                                    </TextStyle>
                                                                </h3>
                                                            </ResourceItem>
                                                        )
                                                    }}
                                                /> */}

                                                {listSelected.map((item) => (
                                                    <Card.Section>
                                                        <div className="productGroup">
                                                            <Thumbnail
                                                                source={item.featured_image}
                                                                alt={item.title}
                                                            />
                                                            <h3 className="productName">
                                                                <TextStyle variation="strong">
                                                                    {item.title}
                                                                </TextStyle>
                                                            </h3>
                                                            <Button
                                                                onClick={() =>
                                                                    this.handleDelete(item.id)
                                                                }
                                                                icon={CancelSmallMinor}
                                                                className="Polaris-Button--plain"
                                                            />
                                                        </div>
                                                    </Card.Section>
                                                ))}
                                            </Scrollable>
                                        </Card>
                                    ) : (
                                        ""
                                    )}
                                </Card>
                            </div>
                        </Layout.Section>
                        <Layout.Section>
                            <Card>
                                <Card.Section>
                                    <div className="product-detail__action">
                                        <div>
                                            Pre-order status is{" "}
                                            <span style={{ fontWeight: "bold" }}>
                                                {selectItem.status ? "enabled." : "disable."}
                                            </span>
                                        </div>
                                        <Button
                                            destructive={!selectItem.status}
                                            primary={selectItem.status}
                                            onClick={() => this.hanldeChange("status")}
                                        >
                                            {selectItem.status ? "Enable" : "Disable"}
                                        </Button>
                                    </div>
                                </Card.Section>
                            </Card>

                            <Card title="Pre-order START condition">
                                <Card.Section>
                                    <ChoiceList
                                        choices={[
                                            { label: "Now", value: "now" },
                                            {
                                                label: "Start quantity (equal or less than)",
                                                value: "quantity",
                                            },
                                            { label: "Start date", value: "date" },
                                        ]}
                                        selected={selectItem.startCondition.type}
                                        onChange={(value) =>
                                            this.hanldeChange("startCondition", value)
                                        }
                                    />
                                    {selectItem.startCondition.type == "quantity" && (
                                        <TextField
                                            type="number"
                                            value={selectItem.startCondition.condition}
                                            onChange={(value) =>
                                                this.hanldeChange("startQuantity", value)
                                            }
                                        />
                                    )}
                                    {selectItem.startCondition.type == "date" && (
                                        <DateTimePicker
                                            value={selectItem.startCondition.condition}
                                            className="date-time-picker"
                                            // label="DatePicker Label"
                                            formatStyle="large"
                                            onChange={(value) =>
                                                this.hanldeChange("startDate", value)
                                            }
                                        />
                                    )}
                                </Card.Section>
                                <Card.Section title="OVERSELLING SETTINGS">
                                    <ChoiceList
                                        title={`You must enable "Continue selling when out of stock" to
                                        allow pre-ordering products when sold out`}
                                        choices={[
                                            {
                                                label: `Automatically turn on "Continue selling when out of stock" for all "Track quantity" products`,
                                                value: "auto",
                                            },
                                            {
                                                label: `Keep products' inventory setup, I will enable by myself.`,
                                                value: "none",
                                            },
                                        ]}
                                        selected={selectItem.requiredCondition}
                                        onChange={(value) =>
                                            this.hanldeChange("requiredCondition", value)
                                        }
                                    />
                                </Card.Section>
                            </Card>

                            <Card title="Pre-order STOP conditions">
                                <Card.Section>
                                    <p>
                                        You can select multiple conditions. Pre-order will be
                                        disabled when a condition ends first. If none is selected,
                                        it will end when you manually disable it.
                                    </p>
                                </Card.Section>
                                <Card.Section title="BY INVENTORY QUANTITY">
                                    <FormLayout>
                                        <Checkbox
                                            label="Stop pre-order program when inventory quantity reach to:"
                                            checked={selectItem.endQuantity.check}
                                            onChange={() => this.hanldeChange("checkEndQuantity")}
                                        />
                                        {selectItem.endQuantity.check && (
                                            <TextField
                                                type="number"
                                                value={selectItem.endQuantity.condition}
                                                onChange={(val) =>
                                                    this.hanldeChange("endQuantity", val)
                                                }
                                            />
                                        )}
                                    </FormLayout>
                                </Card.Section>
                                <Card.Section title="BY DATE AND TIME">
                                    <FormLayout>
                                        <Checkbox
                                            label="End date"
                                            checked={selectItem.endDate.check}
                                            onChange={(val) =>
                                                this.hanldeChange("checkEndDate", val)
                                            }
                                        />
                                        {selectItem.endDate.check && (
                                            <DateTimePicker
                                                error={
                                                    selectItem.endDate.condition
                                                        ? ""
                                                        : "Select a date is Required"
                                                }
                                                className="date-time-picker"
                                                value={selectItem.endDate.condition}
                                                // label="DatePicker Label"
                                                formatStyle="large"
                                                onChange={(val) =>
                                                    this.hanldeChange("endDate", val)
                                                }
                                            />
                                        )}
                                        {selectItem.endDate.check && (
                                            <Checkbox
                                                label="Enable Countdown for End date"
                                                checked={selectItem.countdown.endCountdown}
                                                onChange={() => this.hanldeChange("endCountdown")}
                                            />
                                        )}
                                    </FormLayout>
                                </Card.Section>
                            </Card>

                            {/* <Card title="Payment and Discount">
                                <Card.Section>
                                    <p>
                                        Discount & Partial payment feature will allow to redirect to
                                        check-out page( skip the cart page ) when purchasing
                                        pre-order products and just only 1 product could be bought
                                    </p>
                                </Card.Section>
                                <Card.Section>
                                    <p>This feature is limited. Please upgrade your plan to use</p>
                                </Card.Section>
                                <Card.Section>
                                    <FormLayout>
                                        <Checkbox
                                            label="Stop pre-order program when inventory quantity reach to:"
                                            checked={sameVariant}
                                            onChange={() =>
                                                this.setState({ sameVariant: !sameVariant })
                                            }
                                        />
                                        <div>
                                            <Button>Discount</Button>
                                            <TextField
                                                type="number"
                                                value="-10"
                                                onChange={() => {}}
                                            />
                                        </div>
                                        <Checkbox
                                            label="Partial payment"
                                            checked={sameVariant}
                                            onChange={() =>
                                                this.setState({ sameVariant: !sameVariant })
                                            }
                                        />
                                    </FormLayout>
                                </Card.Section>
                            </Card> */}
                        </Layout.Section>
                    </Layout>
                    <PageActions
                        primaryAction={{
                            content: "Save",
                            onAction: () => this.handleSaveProduct(),
                        }}
                    />

                    {/* Sheet  */}

                    <Sheet open={sheetActive} onClose={() => this.handleToggleSheetActive()}>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                height: "100%",
                            }}
                        >
                            <div
                                style={{
                                    alignItems: "center",
                                    borderBottom: "1px solid #DFE3E8",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "1.6rem",
                                    width: "100%",
                                }}
                            >
                                <Heading>Select Product</Heading>
                                <Button
                                    accessibilityLabel="Cancel"
                                    icon={CancelSmallMinor}
                                    onClick={() => this.handleToggleSheetActive()}
                                    plain
                                />
                            </div>
                            <TextField
                                placeholder="Search products"
                                type="search"
                                onChange={(val) => this.handleSearch(val)}
                                value={textSearch}
                                prefix={<Icon source={SearchMinor} />}
                            ></TextField>

                            <Scrollable
                                id="scrollableDiv"
                                style={{ marginTop: "1.6rem", height: "100%" }}
                            >
                                {loading ? (
                                    <Stack distribution="center">
                                        <div style={{ marginTop: "20px", display: "flex" }}>
                                            <Spinner
                                                accessibilityLabel="Loading more customers"
                                                size="large"
                                                color="teal"
                                            />
                                        </div>
                                    </Stack>
                                ) : (
                                    <InfinitScroll
                                        dataLength={all_product.length}
                                        hasMore={true}
                                        next={() => this.handleLoadMore()}
                                        scrollableTarget="scrollableDiv"
                                        loader={
                                            this.state.loadingEndPoint ? (
                                                <Stack distribution="center">
                                                    <svg viewBox="0 0 80 80" height="48" width="48">
                                                        <path
                                                            id="spinner"
                                                            fill="#81D8D8"
                                                            d="M40,72C22.4,72,8,57.6,8,40C8,22.4,
                                                        22.4,8,40,8c17.6,0,32,14.4,32,32c0,1.1-0.9,2-2,2
                                                        s-2-0.9-2-2c0-15.4-12.6-28-28-28S12,24.6,12,40s12.6,
                                                        28,28,28c1.1,0,2,0.9,2,2S41.1,72,40,72z"
                                                        >
                                                            <animateTransform
                                                                attributeType="xml"
                                                                attributeName="transform"
                                                                type="rotate"
                                                                from="0 40 40"
                                                                to="360 40 40"
                                                                dur="0.6s"
                                                                repeatCount="indefinite"
                                                            ></animateTransform>
                                                        </path>
                                                    </svg>
                                                </Stack>
                                            ) : null
                                        }
                                    >
                                        <div>
                                            <OptionList
                                                allowMultiple
                                                onChange={(val) => this.handleSelect(val)}
                                                options={all_product}
                                                selected={selected}
                                            />
                                        </div>
                                    </InfinitScroll>
                                )}
                            </Scrollable>

                            <div
                                style={{
                                    alignItems: "center",
                                    borderTop: "1px solid #DFE3E8",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "1.6rem",
                                    width: "100%",
                                }}
                            >
                                <Button onClick={() => this.handleToggleSheetActive()}>
                                    Cancel
                                </Button>
                                <Button primary onClick={() => this.handlSelectListProduct()}>
                                    Select
                                </Button>
                            </div>
                        </div>
                    </Sheet>
                </Page>
                {toast.show && (
                    <Toast
                        content={toast.content}
                        error={toast.error}
                        onDismiss={() =>
                            this.setState({
                                toast: { show: false, content: "", error: false },
                            })
                        }
                    />
                )}
            </div>
        ) : (
            <Stack distribution="center">
                <div style={{ marginTop: "20px", display: "flex" }}>
                    <Spinner
                        accessibilityLabel="Loading more customers"
                        size="large"
                        color="teal"
                    />
                </div>
            </Stack>
        )
    }
}
